import { useState } from "react";

import type { ModerationActionOptions } from "@/react/components/SettingsApp/Moderation/useModerationApi";
import type { FlaggedContentableType } from "@/react/types";

import { ApproveRejectActions } from "./ApproveRejectActions";
import { RejectWithReasonActions } from "./RejectWithReasonActions";

interface FlaggedContentActionsProps {
  i18nRoot: string;
  isApproving: boolean;
  isAuthorFlagged?: boolean;
  isEmbeddedChat?: boolean;
  isFlaggedForConnect?: boolean;
  isRejecting: boolean;
  onApprove: (options?: ModerationActionOptions) => void;
  onReject: (reason: string | null, options?: ModerationActionOptions) => void;
  status: string | null;
  type: FlaggedContentableType;
}

export const FlaggedContentActions = ({
  type,
  status,
  i18nRoot,
  isApproving,
  isRejecting,
  isAuthorFlagged,
  isEmbeddedChat,
  isFlaggedForConnect,
  onApprove,
  onReject,
}: FlaggedContentActionsProps) => {
  // When opening a review that is approved, the only possible action is to
  // reject, so we can show the second step of the rejection flow right away.
  const [isRejectWithReason, setIsRejectWithReason] = useState(
    status === "approved",
  );
  const [pendingRejectOptions, setPendingRejectOptions] =
    useState<ModerationActionOptions>();

  const handleRejectWithOptions = (options?: ModerationActionOptions) => {
    setPendingRejectOptions(options);
    setIsRejectWithReason(true);
  };

  const handleReject = (reason: string | null) => {
    onReject(reason, pendingRejectOptions);
  };

  return (
    <div className="border-t px-8 py-6">
      {isRejectWithReason ? (
        <RejectWithReasonActions
          i18nRoot={i18nRoot}
          isRejecting={isRejecting}
          onReject={handleReject}
          type={type}
        />
      ) : (
        <ApproveRejectActions
          i18nRoot={i18nRoot}
          isApproving={isApproving}
          isAuthorFlagged={isAuthorFlagged}
          isEmbeddedChat={isEmbeddedChat}
          isFlaggedForConnect={isFlaggedForConnect}
          onApprove={onApprove}
          onReject={handleRejectWithOptions}
          status={status}
          type={type}
        />
      )}
    </div>
  );
};
